
import { useUserActions } from './api'
import { useHistory } from 'react-router-dom'
import { setUserSecret } from 'src/util/helper'
import { AssociateError } from 'src/util/associate'

export default function useAssociate () {

  const { associate } = useUserActions()
  const history = useHistory()

  const associateUser = async (userId: string, urlSecret: string) => {
    try {
      const { email, secret, role } = await associate(urlSecret, userId)
      if (role === 'USER') throw new Error('Invalid role')
      setUserSecret(email, secret)
      history.replace('/')
    } catch (err) {
      if (err.status === 400) { throw new AssociateError('Invalid secret') } else throw err
    }
  }

  return {
    associateUser
  }
}
